import * as React from "react";

export const AppContext = React.createContext<{
  handleLogin: (token: string, cb?: () => void) => void;
  handleLogout: () => void;
}>({
  handleLogin: () => {},
  handleLogout: () => {}
});
